import React, { useEffect, useState, useContext } from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxProduct from "../../util/remote/ajaxProduct"; // or create ajaxMovement
import { Link } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import TableHeader from "../../Components/Common/TableHeader";
import jsPDF from "jspdf";
import Select from "react-select";
import "jspdf-autotable";
import toast, { Toaster } from "react-hot-toast";
import ClientContext from "../../Context/ClientContext";
import ajaxStores from "../../util/remote/ajaxStores";
import useStateCallback from "../../util/customHooks/useStateCallback";
import UpdateStoreMovement from "./UpdateStoreMovement";
function ListStoreMovements() {
  const [movements, setMovements] = useState(false);
  const [loading, setLoading] = useState(false);
  const { clientList } = useContext(ClientContext); // might not be needed
  const [start_date, setStart_date] = useState("");
  const [to_date, setTo_date] = useState("");
  const [fromStoreId, setFromStoreId] = useState("");
  const [toStoreId, setToStoreId] = useState("");
  const [productId, setProductId] = useState("");
  const [productOptions, setProductOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  // Fetch movements with filters
  const fetchMovements = async () => {
    let data = {
      product_id: productId || null,
      old_store_id: fromStoreId || null,
      new_store_id: toStoreId || null,
      date_from: start_date || null,
      date_to: to_date || null,
    };
    setLoading(true);
    const server_response = await ajaxProduct.fetchStoreMovements(data); // need to implement this
    setLoading(false);
    if (server_response.status === "OK") {
      setMovements(server_response.details);
    } else {
      setMovements(false);
      toast.error(server_response.message || "No movements found");
    }
  };
  useEffect(() => {
    fetchMovements();
  }, [fromStoreId, toStoreId, productId, start_date, to_date]);
  // Load product options for filter
  const loadProducts = async () => {
    const res = await ajaxProduct.fetchProductList(); // assume exists
    if (res.status === "OK") {
      setProductOptions(res.details);
    }
  };
  const loadStores = async () => {
    const res = await ajaxStores.fetchStores();
    if (res.status === "OK") {
      setStoreOptions(res.details);
    }
  };
  useEffect(() => {
    loadProducts();
    loadStores();
    const today = new Date().toISOString().split("T")[0];
    setTo_date(today);
  }, []);
  const resetFilters = (e) => {
    e.preventDefault();
    setFromStoreId("");
    setToStoreId("");
    setProductId("");
    setStart_date("");
    setTo_date("");
  };
  // Delete movement (reverse)
  const handleDelete = async (movementId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this transfer? It will reverse all stock movements.",
    );
    if (!confirm) return;
    const res = await ajaxProduct.deleteStoreMovement(movementId);
    if (res.status === "OK") {
      toast.success(res.message);
      fetchMovements();
    } else {
      toast.error(res.message);
    }
  };
  // Export to PDF (similar to delivery notes)
  const exportToPDF = () => {
    const table = document.querySelector(".movements-table");
    if (!table) return;
    const pdf = new jsPDF("p", "pt", "a4");
    const companyName = "BERICOT AFRICA LIMITED";
    const companyAddress = "KAMPALA UGANDA \n TEL:+256701666160";
    const currentDate = `Date of Printing: ${new Date().toLocaleDateString()}`;
    const headerDescription = "Store Transfer Movements Report";
    const pageWidth = pdf.internal.pageSize.getWidth();
    pdf.setFontSize(14);
    const companyNameWidth = pdf.getTextWidth(companyName);
    pdf.text(companyName, (pageWidth - companyNameWidth) / 2, 50);
    pdf.setFontSize(12);
    const addressLine1 = companyAddress.split("\n")[0];
    const addressLine2 = companyAddress.split("\n")[1];
    pdf.text(
      addressLine1,
      (pageWidth - pdf.getTextWidth(addressLine1)) / 2,
      80,
    );
    pdf.text(
      addressLine2,
      (pageWidth - pdf.getTextWidth(addressLine2)) / 2,
      100,
    );
    pdf.setFontSize(9);
    const dateWidth = pdf.getTextWidth(currentDate);
    pdf.text(currentDate, (pageWidth - dateWidth) / 2, 130);
    pdf.setFontSize(12);
    const headerWidth = pdf.getTextWidth(headerDescription);
    pdf.text(headerDescription, (pageWidth - headerWidth) / 2, 160);
    const columns = [
      "Date",
      "Product",
      "From Store",
      "To Store",
      "Quantity",
      "Reference",
    ];
    const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) => {
      const cells = row.querySelectorAll("td");
      return [
        cells[0]?.innerText || "",
        cells[1]?.innerText || "",
        cells[2]?.innerText || "",
        cells[3]?.innerText || "",
        cells[4]?.innerText || "",
        cells[5]?.innerText || "",
      ];
    });
    pdf.autoTable({
      startY: 180,
      head: [columns],
      body: rows,
    });
    pdf.save(`store_movements_${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  // cost  updating
  const [update, setUpdate] = useStateCallback(false);
  const handleUpdateClick = (mov) => {
    setUpdate(false, () =>
      setUpdate(
        <UpdateStoreMovement
          isOpen={true}
          function={fetchMovements}
          data={mov}
        />,
      ),
    );
  };

  return (
    <AppContainer title="Store Transfer Movements">
      <Toaster />
      <div
        className="row clearfix"
        style={{ marginRight: "-5px", marginLeft: "-5px" }}
      >
        <div
          className="col-lg-12 col-md-12 col-sm-12"
          style={{ paddingRight: "5px", paddingLeft: "5px" }}
        >
          <div className="card mb-1" style={{ borderRadius: ".55rem" }}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <b>Product:</b>
                  <Select
                    onChange={(e) => setProductId(e.id)}
                    getOptionLabel={(option) => option.product_name}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={productOptions}
                    value={productOptions.find((p) => p.id === productId) || ""}
                    placeholder="All products"
                  />
                </div>
                <div className="col-md-2">
                  <b>From Store:</b>
                  <Select
                    onChange={(e) => setFromStoreId(e.id)}
                    getOptionLabel={(option) => option.storeName}
                    getOptionValue={(option) => option.id}
                    options={storeOptions}
                    value={storeOptions.find((s) => s.id === fromStoreId) || ""}
                    placeholder="All stores"
                  />
                </div>
                <div className="col-md-2">
                  <b>To Store:</b>
                  <Select
                    onChange={(e) => setToStoreId(e.id)}
                    getOptionLabel={(option) => option.storeName}
                    getOptionValue={(option) => option.id}
                    options={storeOptions}
                    value={storeOptions.find((s) => s.id === toStoreId) || ""}
                    placeholder="All stores"
                  />
                </div>
                <div className="col-md-2">
                  <b>From Date:</b>
                  <input
                    type="date"
                    className="form-control"
                    value={start_date}
                    onChange={(e) => setStart_date(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <b>To Date:</b>
                  <input
                    type="date"
                    className="form-control"
                    value={to_date}
                    onChange={(e) => setTo_date(e.target.value)}
                  />
                </div>
                <div className="col-md-2 mt-4">
                  <button onClick={resetFilters} className="btn btn-primary">
                    Reset Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card custom-card">
        <div className="card-body">
          {loading && <Loader />}
          {update}
          <TableHeader
            title="Store Transfer Movements"
            subtitle="List of all inventory transfers between stores"
            viewButton={
              <>
                <button
                  onClick={exportToPDF}
                  className="btn btn-secondary btn-sm mr-2"
                  style={{ float: "right", borderRadius: "5px" }}
                >
                  Export to PDF
                </button>
                <Link
                  to="/inventory/create-transfer"
                  className="btn btn-success mb-4 mr-2 btn-sm"
                  style={{ float: "right", borderRadius: "5px" }}
                >
                  Add New Transfer
                </Link>
              </>
            }
          />
          <div className="table-responsive">
            <table className="table table-striped table-bordered movements-table">
              <thead>
                <tr>
                  <th>Transfer Date</th>
                  <th>Product</th>
                  <th>From Store</th>
                  <th>To Store</th>
                  <th>Quantity</th>
                  <th>Reference</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {!movements && (
                  <tr>
                    <td colSpan="8">No movements found</td>
                  </tr>
                )}
                {movements &&
                  movements.map((mov) => (
                    <tr key={mov.movement_id}>
                      <td>{mov.transfer_date}</td>
                      <td>{mov.product_name}</td>
                      <td>{mov.from_store}</td>
                      <td>{mov.to_store}</td>
                      <td>
                        {mov.quantity} {mov.unit_measure}
                      </td>
                      <td>{mov.reference || "-"}</td>
                      <td>{mov.notes || "-"}</td>
                      <td>
                        <button
                          onClick={() => handleUpdateClick(mov)}
                          className="btn btn-warning btn-sm"
                        >
                          Edit
                        </button>
                        {/* <Link
                          to={`/inventory/edit-transfer/${mov.movement_id}`}
                          className="btn btn-warning btn-sm mr-1"
                        >
                          Edit
                        </Link> */}
                        <button
                          onClick={() => handleDelete(mov.movement_id)}
                          className="btn btn-danger btn-sm"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}
export default ListStoreMovements;
